import React from "react";
import { Box, Typography } from "@mui/material";

import { AsyncOperationState } from "fond/async/redux";
import { inputLayerGroups } from "fond/layers";
import { useAppDispatch } from "fond/utils/hooks";
import { isMultiProject } from "fond/utils/project";
import { useStackedNavigationContext } from "fond/widgets";
import StackedNavigationHeader from "fond/widgets/StackedNavigation/StackedNavigationHeader";

import { PolygonState } from "../polygon/redux";
import { closePolygonSelect } from "../redux";

import PolygonSelectBody from "./polygon/PolygonSelectBody";
import { usePolygonSelect } from "./polygon/usePolygonSelect";

const PolygonSelectPanel: React.FC = () => {
  const dispatch = useAppDispatch();
  const polygonSelect = usePolygonSelect();
  const {
    polygon: { polygonState, downloadState },
    activeLayerGroupId,
    project,
    upload,
    importSelectedArea,
  } = polygonSelect;
  const { open, goBack, clear } = useStackedNavigationContext();

  const activeLayerName = activeLayerGroupId && inputLayerGroups[activeLayerGroupId]?.name;

  const handleBack = () => {
    dispatch(closePolygonSelect());

    if (upload && upload.uploadComplete) {
      /**
       * If user's polygon upload is completed but data is being processed,
       * back button should navigate user back to root panel
       */
      clear();
    } else {
      goBack(2);
    }
  };

  const onImportButtonClick = () => {
    importSelectedArea();
    open("import-data");
  };

  if (!project || isMultiProject(project)) {
    return null;
  }

  const isUploading = !!upload || polygonState === PolygonState.uploadingPolygon;
  const showLayerName = isUploading || polygonState !== PolygonState.complete || downloadState !== AsyncOperationState.success;

  return (
    <>
      <StackedNavigationHeader onBackButtonClick={handleBack} title={isUploading ? "Upload Polygon" : "Draw Polygon"} />
      {showLayerName && (
        <Box px={1} mb={2}>
          <Typography fontWeight="500">{activeLayerName}</Typography>
        </Box>
      )}
      <PolygonSelectBody polygonSelect={polygonSelect} onImport={onImportButtonClick} onCancel={handleBack} />
    </>
  );
};

export default PolygonSelectPanel;
